// @ts-nocheck
import { populate } from 'populate';
import type { Container } from 'pixi.js';

const raw = {
  list: [
    {
      id: '078b758d-c5cf-4e31-be34-334304af7803',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '5707b4ed-deca-4c87-a1b1-e91ca9d0d718',
      type: 'Container',
      name: 'offerSlot',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '078b758d-c5cf-4e31-be34-334304af7803'
    },
    {
      id: '75cd3361-2170-4ace-a55f-ed592613bbc3',
      type: 'Container',
      name: 'adCountdownSlot',
      className: '',
      x: 0,
      y: 50,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '078b758d-c5cf-4e31-be34-334304af7803'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '4.0.1',
  handleResize: false
} as const;

export class AdFallbackTemplateLayout {
  static raw = raw;
  root!: Container;
  offerSlot!: Container;
  adCountdownSlot!: Container;
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
